import {
    Typography,
    makeStyles,
    CardContent,
    Card,
    Grid,
    CardMedia,
    CardActions,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { db } from "../../../../../firebase";
import logo from '../../../../../assets/logo.png'
import ForSaleEssentialsListLoading from "./for-sale-essentials-list-loading";
import ForSaleEssentialsListEmpty from "./for-sale-essentials-list-empty";
import { getForSaleEssentialsService } from "./for-sale-essentials-list-service";
import { Link } from "react-router-dom";
import { showErrorSnackbar } from "../../../../shared/snackbar/snackbar-slice";

const useStyles = makeStyles((theme) => ({
    tableHeader: {
      background: "#111111",
      height: "100%",
      color: "#fbbbd3",
      fontSize: 14,
    },
    button: {
      background: "#111111",
      color: "#fbbbd3",
      justifyContent: "right"
    },
    text: {
      color: "#111111",
    },
    title: {
      color:"#111111",
      marginBottom: 20,
    }
}));

const ForSaleEssentialsList = () => {
    const classes = useStyles();
    const forSaleEssentialsCollection = useSelector((state) => state.forSaleEssentialsListSlice.rows);
    const isLoading = useSelector((state) => state.forSaleEssentialsListSlice.isLoading);
    const dispatch = useDispatch();

    // get data
    useEffect(() => {
        const fetchData = async () => {
            try {
                await getForSaleEssentialsService(dispatch, db, "items");
            } catch(e) {
                dispatch(showErrorSnackbar("Something went wrong while trying to fetch."));
                console.error("ForSaleEssentialsList getForSaleEssentialsService error: ", e);
            }
        };
        fetchData();
    }, [dispatch]);

    // return loading state if isLoading is true
    if (isLoading) {
        return <ForSaleEssentialsListLoading/>
    }

    // return empty state if isLoading is false and forSaleEssentialsCollection has no collection
    if (!isLoading && forSaleEssentialsCollection.length === 0) {
        return <ForSaleEssentialsListEmpty/>
    }

    return (
        <>
            <Typography className={classes.title} variant="h4">For Sale Essentials</Typography>
            <Grid container spacing={1}>
                {forSaleEssentialsCollection.map((row) => (
                    <Grid item xs={6} sm={4} md={3} lg={2}>
                        <Link
                            // to={`/app/for-sale/cosplay-essentials/details/${row.id}`}
                            style={{ textDecoration: 'none' }}
                        >
                            <Card variant="outlined">
                                <CardMedia
                                    component="img"
                                    height="194"
                                    image={row.item_thumbnail ? row.item_thumbnail : logo}
                                    alt="PeriCoCo"
                                />
                                <CardContent>
                                    <Typography variant="h5" component="div" className={classes.text} align="left">
                                        {row.name}
                                    </Typography>
                                    <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                                        {`Price: PHP ${row.unit_price}`}
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Typography sx={{ mb: 1.5 }} variant="overline" className={classes.text}>
                                        {row.status}
                                    </Typography>
                                </CardActions>
                            </Card>
                        </Link>
                    </Grid>
                ))}
            </Grid>
        </>
        
    )
};

export default ForSaleEssentialsList;